<template>
    <ShadowBoxContainer>
        <ListContainer 
            :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
            imageLabel="General Information"
            heading="Add some photos."
            :step="3"
        >
            <!-- photo containers -->
            <div class="flex flex-wrap ph3 ph4-ns pb3">
                <div class="w-third pa1 pa2-ns pa3-l">
                    <InsertPhoto  :image="require(`@/assets/img/icon_add_photos.svg`)" @click="$refs.file.click()" />
                </div>
                <div v-for="(file, index) in listing.files" :key="index" class="w-third pa1 pa2-ns pa3-l">
                    <EditPhoto   :image="file" :link="'edit-photo/' + index"/>
                </div>
            </div>
            <input type="file" accept="image/*" ref="file" @change="addFiles($event.target.files)" class="dn" />
            
        </ListContainer>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" forward="Next" :enabledForward="listing.files.length > 0" @backClick="$router.push('/brand')" @forwardClick="$router.push('/description')" />
        </template>
        
    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import InsertPhoto from '@/components/list/addPhotos/InsertPhoto.vue';
import EditPhoto from '@/components/list/addPhotos/EditPhoto.vue';
import EmptyPhoto from '@/components/list/addPhotos/EmptyPhoto.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        ShadowBoxContainer,
        ListContainer,
        InsertPhoto,
        EditPhoto,
        EmptyPhoto,
        NavigationButtons
    },
    computed: {
        ...mapState('newListing', ['listing'])
    },
    methods: {
        ...mapMutations('newListing', ['addFiles'])
    }
};
</script>
